import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {CreateButton, useListContext} from 'react-admin';
import NotFound from "./images/notfound.png";
import "./empty.css";
import Button from "@material-ui/core/Button";
import {ButtonGroup} from "@material-ui/core";
import PublishIcon from "@material-ui/icons/Publish";
import * as React from "react";


const Empty = () => {
    const {basePath} = useListContext();
    return (
        <>
            <Box textAlign="center" m={1} marginTop={20}>
                <Typography variant="h4" className="Title">
                    Nessun elemento trovato...
                </Typography>
                <br></br>
                <img src={NotFound} alt="Nessun elemento presente" width={400}/> <br/>
                <ButtonGroup variant="contained" aria-label="outlined primary button group" style={{
                    marginTop: "2%"
                }}>
                    <CreateButton basePath={basePath} label="Crea Nuovo"/>
                    <Button href={"#/import-csv"}><PublishIcon/> Importa</Button>
                </ButtonGroup>

            </Box>
        </>
    );
};

export default Empty;